module.exports = __webpack_public_path__ + "img/agpz-truck-disabled.33d04d45.svg";